// import slider images
import Avatar1 from '../src/assets/img/avt1.png';
import Avatar2 from '../src/assets/img/avt2.png';
import Avatar3 from '../src/assets/img/avt3.png';

export const slider = [
  {
    message:
      'I know in real-time where the money is spent,and I don’t have to lend out the company’s credit card anymore. What a relief!',
    image: Avatar1,
    name: 'Laurie Howell',
    email: 'la.howell@gmail.com',
  },
  {
    message:
      'VISUALS are much better. The improvements in optics and resolution and much more than a modern console generation leap.',
    image: Avatar2,
    name: 'Christie Ernser',
    email: 'chr.ernser@gmail.com',
  },
  {
    message:
      'I can actually see the improvement in the graphics, not having the external sensors is a big plus.',
    image: Avatar3,
    name: 'Frankie Collins',
    email: 'frank.collins@gmail.com',
  },
  {
    message:
      'I know in real-time where the money is spent,and I don’t have to lend out the company’s credit card anymore. What a relief!',
    image: Avatar1,
    name: 'Laurie Howell',
    email: 'la.howell@gmail.com',
  },
  {
    message:
      'VISUALS are much better. The improvements in optics and resolution and much more than a modern console generation leap.',
    image: Avatar2,
    name: 'Christie Ernser',
    email: 'chr.ernser@gmail.com',
  },
  {
    message:
      'I can actually see the improvement in the graphics, not having the external sensors is a big plus.',
    image: Avatar3,
    name: 'Frankie Collins',
    email: 'frank.collins@gmail.com',
  },
];
